import http from '@/config/api';
import router from '@/router';
import { CommonConstants } from '@/config/constant';

export default {
  async getParentEventInfo({ commit }) {
    const response = await http.get('/event').then(
      (res) => res.data,
      () => null
    );
    if (response) commit('SET_PARENT_EVENT_INFO', response?.list);
    return response?.list;
  },
  async getSubParentEventInfo({ commit, getters }) {
    const response = await http.get('/event/validate-entry').then(
      (res) => res.data,
      () => null
    );
    if (response) {
      commit('SET_PARENT_EVENT_INFO', {
        ...getters.parentEventInfo,
        ...response?.list
      });
    }
    return response?.list;
  },
  async getChildEventInfo({ commit }, params) {
    const directory = params?.directory || router.currentRoute.value?.params.directory;
    const response = await http.get(`/event/${directory}`, {
      params: { ...params },
    }).then(
      (res) => res.data,
      () => null
    );
    if(response) commit('SET_CHILD_EVENT_INFO', response);
  },
  async updateCivilios({ commit }, payload) {
    const response = await http.post('/civilios', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    if (response) {
      if (response.message === CommonConstants.typeDuplicate) {
        commit('SET_DUPLICATE_USER', true);
      } else if (response.message === CommonConstants.typeError) {
        commit('SET_ERROR_USER', true);
      } else if (response.message === CommonConstants.typeErrorAddress) {
        commit('SET_ERROR_ADDRESS', true);
      } else {
        commit('SET_VALID_USER', true);
      }
    }
    return response;
  },
  async getIdentityCivilios(_, payload) {
    const response = await http.get(`${payload.host}/realms/${payload.realm}/protocol/openid-connect/auth`, {
      params: {
        response_type: payload.response_type,
        client_id: payload.client_id,
        redirect_uri: payload.redirect_uri,
        scope: payload.scope,
      },
      hasCustomConfig: true,
    }).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async sendSmsCode({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`/event/${directory}/sms`, payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    if(response) commit('SET_PHONE_INFO', response);
    return response;
  },
  async sendSmsVerify(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`/event/${directory}/sms/verify`, payload, { checkBlockedSms: true }).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async getSmsStatus(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.get(`/event/${directory}/sms/${payload.messageId}`).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async getIdentityXID(_, params) {
    const response = await http.get(`${process.env.VUE_APP_XID_DOMAIN || ''}oauth2/auth`, { params }).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async getIdentityDigital(_, payload) {
    const { host, ...paramsWithoutHost } = payload;
    const response = await http.get(`${host}realms/main/protocol/openid-connect/auth`, {
      params: {
        ...paramsWithoutHost,
      },
      hasCustomConfig: true,
    }).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async updateCiviliosWithoutAuth({ commit }, payload) {
    const response = await http.post('/civilios/without/auth', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    if (response) {
      if (response.message === CommonConstants.typeDuplicate) {
        commit('SET_DUPLICATE_USER', true);
      } else if (response.message === CommonConstants.typeError) {
        commit('SET_ERROR_USER', true);
      } else if (response.message === CommonConstants.typeErrorAddress) {
        commit('SET_ERROR_ADDRESS', true);
      } else {
        commit('SET_VALID_USER', true);
      }
    }
    return response;
  },
  async updateDigital({ commit }, payload) {
    const response = await http.post('/digital/identity', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    if (response) {
      if (response.message === CommonConstants.typeDuplicate) {
        commit('SET_DUPLICATE_USER', true);
      } else if (response.message === CommonConstants.typeError) {
        commit('SET_ERROR_USER', true);
      } else if (response.message === CommonConstants.typeErrorAddress) {
        commit('SET_ERROR_ADDRESS', true);
      } else {
        commit('SET_VALID_USER', true);
      }
    }
    return response;
  },
  async updateDigitalWithoutAuth({ commit }, payload) {
    const response = await http.post('digital/without/auth', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    if (response) {
      if (response.message === CommonConstants.typeDuplicate) {
        commit('SET_DUPLICATE_USER', true);
      } else if (response.message === CommonConstants.typeError) {
        commit('SET_ERROR_USER', true);
      } else if (response.message === CommonConstants.typeErrorAddress) {
        commit('SET_ERROR_ADDRESS', true);
      } else {
        commit('SET_VALID_USER', true);
      }
    }
    return response;
  },
  setBlockUser({ commit }, data) {
    commit('SET_BLOCK_USER', data);
  },
};
